import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'
import { patch } from "@lib/requests"
import { showAlert } from "@lib/utils"

// Connects to data-controller="item-swap"

export default class extends Controller {

  static values = {
    path: String
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      chosenClass: "bg-blue-50",
      onUpdate: (event) => {
        const itemId = event?.item?.id
        const newIndex = event?.newIndex
        const newPosition = newIndex + 1

        if (!itemId) return console.error("No item id provided for reordering")
        if (!this.hasPathValue) return console.error("No path value provided for reordering")

        const fullPath = `/${this.pathValue}/${itemId}/reorder?position=${newPosition}`
        patch(fullPath)
          .then(() => {
            showAlert("Position de l'élément mise à jour", { type: "success" })
          })
          .catch(() => {
            showAlert("Erreur lors de la mise à jour de la position", { type: "error" })
          })
      }
    })
  }

}
